import React from 'react';
import { Form, Select } from 'antd';
import { useTranslation } from 'react-i18next';

interface AverageTimeFieldProps {
  options: Array<{ label: string; value: string }>;
  loading: boolean;
  disabled?: boolean;
}

export function AverageTimeField({
  options,
  loading,
  disabled = false,
}: AverageTimeFieldProps) {
  const { t } = useTranslation('create-alarm-step');

  return (
    <>
      <Form.Item
        name="averageTime"
        label={t('create-alarm-step:stepOne.createAlarmAverageTimeField')}
        rules={[
          {
            required: true,
            message: t(
              'create-alarm-step:stepOne.createAlarmAverageTimeRequired',
            ),
          },
        ]}
      >
        <Select
          allowClear
          options={options}
          loading={loading}
          disabled={loading || disabled}
          style={{ textAlign: 'left' }}
        />
      </Form.Item>
    </>
  );
}
